var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.product.price
    ? _c("div", { class: [_vm.homeStyle ? "home-style" : "", "point-price"] }, [
        _c(
          "div",
          [
            _c("p", { staticClass: "price-warp" }, [
              _c("span", { staticClass: "origin-price" }),
              _c("span", { staticClass: "real-price" }, [
                _c("span", { staticClass: "rmb" }, [_vm._v("原价：￥")]),
                _vm._v(_vm._s(_vm.originPrice)),
              ]),
            ]),
            _vm.showRatio
              ? [
                  _vm.memberRatio != 0
                    ? _c("span", { staticClass: "points" }, [
                        _c("span", [_vm._v("会员积分抵扣")]),
                        _c("span", { staticClass: "points-num" }, [
                          _vm._v(_vm._s(_vm.memberRatio) + "%"),
                        ]),
                      ])
                    : _vm._e(),
                ]
              : _vm._e(),
            !_vm.showRatio
              ? [
                  _vm.product.memberRatio != 0
                    ? _c("span", { staticClass: "points" }, [
                        _vm._v(" +" + _vm._s(_vm.pointsDeduction) + "积分"),
                      ])
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }